module.exports = __webpack_public_path__ + "img/1.65e066a2.png";